"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Table_1 = __importDefault(require("react-bootstrap/Table"));
var react_router_dom_1 = require("react-router-dom");
var AcTableHeader_1 = require("./AcTableHeader");
var AcTableActionCell_1 = require("./AcTableActionCell");
var UseAcTableData_1 = require("./UseAcTableData");
var AcTableSelectorCell_1 = require("./AcTableSelectorCell");
var AcTableContactCell_1 = require("./AcTableContactCell");
var AcTable_module_scss_1 = __importDefault(require("./AcTable.module.scss"));
var AcTableNoData_1 = __importDefault(require("./AcTableNoData"));
var AcTableRow_1 = require("./AcTableRow");
/**
 * Generic
 * T - type of the item data
 * F - type of the function context
 */
exports.AcTable = function (props) {
    var loading = props.loading, size = props.size, sorts = props.sorts, onSort = props.onSort, onSelectRows = props.onSelectRows, onRowClick = props.onRowClick, onRowExpand = props.onRowExpand, onSelectPageSize = props.onSelectPageSize, highlight = props.highlight, functionContext = props.functionContext, whenLoading = props.whenLoading, whenNoData = props.whenNoData, hideHeader = props.hideHeader, columns = props.columns, data = props.data, activeData = props.activeData;
    var _a = UseAcTableData_1.useAcTableData({
        columns: columns,
        data: data,
        functionContext: functionContext,
        highlight: highlight,
    }), acTableColumns = _a.acTableColumns, acTableItems = _a.acTableItems, selectItem = _a.selectItem, selectAllItems = _a.selectAllItems, setData = _a.setData, setColumns = _a.setColumns;
    react_1.useEffect(function () {
        // also update columns when updating on data
        setColumns(columns);
        setData(data || []);
    }, [data]);
    var history = react_router_dom_1.useHistory();
    var onSelectItem = function (item) {
        selectItem(item.index);
        if (onSelectRows) {
            // onSelectRows(getSelectedData(), functionContext);
        }
    };
    var onSelectAllItems = function (checked) {
        selectAllItems(checked);
        if (onSelectRows) {
            // onSelectRows(getSelectedData(), functionContext);
        }
    };
    var createCell = function (acTableColumn, index, acTableItem) {
        if (acTableColumn.selector) {
            return (react_1.default.createElement(AcTableSelectorCell_1.AcTableSelectorCell, { key: index, item: acTableItem, selected: acTableItem.selected, onSelect: onSelectItem }));
        }
        if (acTableColumn.actions) {
            return (react_1.default.createElement(AcTableActionCell_1.AcTableActionCell, { key: index, actions: acTableColumn.actions, data: acTableItem.data, functionContext: functionContext }));
        }
        if (acTableColumn.contacts) {
            return react_1.default.createElement(AcTableContactCell_1.AcTableContactCell, { key: index, contacts: acTableColumn.contacts });
        }
        if (acTableColumn.data) {
            var value = acTableColumn.buildValue(acTableItem.data);
            var linkWrapper = function (el) {
                return react_1.default.createElement(react_1.default.Fragment, null, el);
            };
            if (acTableColumn.hasPath()) {
                var path_1 = acTableColumn.buildPath(acTableItem.data);
                var onClick_1 = function () {
                    history.push(path_1);
                };
                linkWrapper = function (el) { return (react_1.default.createElement("a", { href: "javascript:void(0);", onClick: onClick_1 }, el)); };
            }
            return react_1.default.createElement(react_1.default.Fragment, null, linkWrapper(value));
        }
        return null;
    };
    var rows = acTableItems.map(function (acTableItem, rowIndex) {
        var cols = acTableColumns
            .filter(function (acTableColumn) { return acTableColumn.display; })
            .map(function (acTableColumn, index) {
            if (acTableColumn.display) {
                var cell = createCell(acTableColumn, rowIndex + index, acTableItem);
                var cellWidth = 'auto';
                if (acTableColumn.actions) {
                    cellWidth = acTableColumn.actions.length * 50 + "px";
                }
                if (acTableColumn.width) {
                    cellWidth = acTableColumn.width + "px";
                }
                return (react_1.default.createElement("td", { key: index, className: "align-middle fs-12 " + acTableColumn.className + " " + AcTable_module_scss_1.default.tableCell, style: {
                        width: cellWidth,
                    } }, cell));
            }
        });
        return (react_1.default.createElement(AcTableRow_1.AcTableRow, { key: rowIndex, data: acTableItem.data, activeData: activeData, highlight: highlight, functionContext: functionContext, onRowClick: onRowClick, onRowExpand: onRowExpand }, cols));
    });
    return (react_1.default.createElement("div", { className: "table-responsive", style: { minHeight: '400px', position: 'relative', overflowY: 'hidden' } },
        !loading && (!rows || rows.length === 0) && (react_1.default.createElement(AcTableNoData_1.default, null, whenNoData || react_1.default.createElement("p", { className: "fs-18 font-weight-bold" }, "\u8868\u793A\u3067\u304D\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093"))),
        rows && rows.length > 0 && (react_1.default.createElement(Table_1.default, { className: AcTable_module_scss_1.default.table },
            !hideHeader && (react_1.default.createElement(AcTableHeader_1.AcTableHeader, { columns: acTableColumns, sorts: sorts, onSort: onSort, onSelectAll: onSelectAllItems, pageSize: size, onSelectPageSize: onSelectPageSize })),
            react_1.default.createElement("tbody", null, rows))),
        loading && (react_1.default.createElement("div", { className: AcTable_module_scss_1.default.tableLoadingOverlay },
            react_1.default.createElement("div", { style: { height: '64px' }, className: "rounded shadow p-4 d-flex m-auto bg-white" }, whenLoading || react_1.default.createElement("i", { className: "fas fa-2x fa-spin fa-spinner text-cloudLink" }))))));
};
exports.AcTable.displayName = 'AcTable';
exports.AcTable.defaultProps = {
    columns: [],
    data: [],
};
//# sourceMappingURL=AcTable.js.map